const CARD_FONT = '"Piedra", "Trebuchet MS", sans-serif';
const CARD_COLORS = {
    red: '#E74C3C',
    yellow: '#F39C12',
    green: '#27AE60',
    blue: '#3498DB'
};

const sizes = {
    small: { width: 60, height: 90, fontSize: 24, cornerSize: 12 },
    normal: { width: 80, height: 120, fontSize: 32, cornerSize: 16 },
    large: { width: 100, height: 150, fontSize: 40, cornerSize: 20 }
};

function hexToRgba(hex, alpha = 1) {
    const value = hex.replace('#', '');
    const normalized = value.length === 3
        ? value.split('').map((char) => `${char}${char}`).join('')
        : value;

    const intValue = Number.parseInt(normalized, 16);
    const red = (intValue >> 16) & 255;
    const green = (intValue >> 8) & 255;
    const blue = intValue & 255;

    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}

function WildSquares() {
    return (
        <>
            <rect x="30" y="55" width="15" height="15" fill="#E74C3C" />
            <rect x="55" y="55" width="15" height="15" fill="#F39C12" />
            <rect x="30" y="80" width="15" height="15" fill="#27AE60" />
            <rect x="55" y="80" width="15" height="15" fill="#3498DB" />
        </>
    );
}

function NumberFace({ value, fontSize, cornerSize, cardColor }) {
    const cornerLabel = value === '0' ? '\u27F3' : value === '7' ? '\u21C4' : value;
    return (
        <>
            <text x="50" y="90" fontSize={fontSize} fontWeight="900" fill={cardColor} textAnchor="middle">{value}</text>
            <text x="15" y="25" fontSize={cornerSize} fontWeight="900" fill="white" textAnchor="middle">{cornerLabel}</text>
            <text x="85" y="140" fontSize={cornerSize} fontWeight="900" fill="white" textAnchor="middle">{cornerLabel}</text>
        </>
    );
}

function ActionFace({ value, cornerSize, cardColor, fontSize }) {
    if (value === 'skip') {
        return (
            <>
                <circle cx="50" cy="75" r="25" fill="none" stroke={cardColor} strokeWidth="4" />
                <line x1="30" y1="95" x2="70" y2="55" stroke={cardColor} strokeWidth="4" />
                <text x="15" y="25" fontSize={cornerSize} fontWeight="bold" fill="white" textAnchor="middle">SK</text>
                <text x="85" y="140" fontSize={cornerSize} fontWeight="bold" fill="white" textAnchor="middle">SK</text>
            </>
        );
    }

    if (value === 'skip_everyone') {
        return (
            <>
                <circle cx="35" cy="65" r="15" fill="none" stroke={cardColor} strokeWidth="3" />
                <circle cx="50" cy="75" r="15" fill="none" stroke={cardColor} strokeWidth="3" />
                <circle cx="65" cy="85" r="15" fill="none" stroke={cardColor} strokeWidth="3" />
                <line x1="20" y1="50" x2="80" y2="100" stroke={cardColor} strokeWidth="4" />
                <text x="15" y="25" fontSize={cornerSize - 2} fontWeight="bold" fill="white" textAnchor="middle">SE</text>
                <text x="85" y="140" fontSize={cornerSize - 2} fontWeight="bold" fill="white" textAnchor="middle">SE</text>
            </>
        );
    }

    if (value === 'reverse') {
        return (
            <>
                <path d="M 30 60 Q 35 50, 45 50 L 45 45 L 55 55 L 45 65 L 45 60 Q 37 60, 32 65" fill={cardColor} />
                <path d="M 70 90 Q 65 100, 55 100 L 55 105 L 45 95 L 55 85 L 55 90 Q 63 90, 68 85" fill={cardColor} />
                <text x="15" y="25" fontSize={cornerSize} fontWeight="bold" fill="white" textAnchor="middle">R</text>
                <text x="85" y="140" fontSize={cornerSize} fontWeight="bold" fill="white" textAnchor="middle">R</text>
            </>
        );
    }

    if (value === 'draw2') {
        return (
            <>
                <text x="50" y="90" fontSize={fontSize} fontWeight="900" fill={cardColor} textAnchor="middle">+2</text>
                <text x="15" y="25" fontSize={cornerSize} fontWeight="bold" fill="white" textAnchor="middle">+2</text>
                <text x="85" y="140" fontSize={cornerSize} fontWeight="bold" fill="white" textAnchor="middle">+2</text>
            </>
        );
    }

    if (value === 'discard_all') {
        return (
            <>
                <rect x="30" y="60" width="20" height="30" rx="2" fill={cardColor} opacity="0.7" />
                <rect x="37" y="65" width="20" height="30" rx="2" fill={cardColor} opacity="0.8" />
                <rect x="44" y="70" width="20" height="30" rx="2" fill={cardColor} />
                <text x="54" y="92" fontSize="24" fontWeight="bold" fill="white" textAnchor="middle">×</text>
                <text x="15" y="25" fontSize={cornerSize - 2} fontWeight="bold" fill="white" textAnchor="middle">DA</text>
                <text x="85" y="140" fontSize={cornerSize - 2} fontWeight="bold" fill="white" textAnchor="middle">DA</text>
            </>
        );
    }

    return (
        <>
            <text x="50" y="82" fontSize={fontSize * 0.55} fontWeight="900" fill={cardColor} textAnchor="middle">{value}</text>
            <text x="15" y="25" fontSize={cornerSize - 3} fontWeight="bold" fill="white" textAnchor="middle">A</text>
            <text x="85" y="140" fontSize={cornerSize - 3} fontWeight="bold" fill="white" textAnchor="middle">A</text>
        </>
    );
}

function WildFace({ value, cornerSize }) {
    if (value === 'wild') {
        return (
            <>
                <WildSquares />
                <text x="15" y="25" fontSize={cornerSize - 2} fontWeight="bold" fill="white" textAnchor="middle">W</text>
                <text x="85" y="140" fontSize={cornerSize - 2} fontWeight="bold" fill="white" textAnchor="middle">W</text>
            </>
        );
    }

    if (value === 'wild_draw4') {
        return (
            <>
                <WildSquares />
                <text x="50" y="115" fontSize="20" fontWeight="900" fill="#2C3E50" textAnchor="middle">+4</text>
                <text x="15" y="25" fontSize={cornerSize - 2} fontWeight="bold" fill="white" textAnchor="middle">+4</text>
                <text x="85" y="140" fontSize={cornerSize - 2} fontWeight="bold" fill="white" textAnchor="middle">+4</text>
            </>
        );
    }

    if (value === 'wild_draw6') {
        return (
            <>
                <WildSquares />
                <text x="50" y="115" fontSize="20" fontWeight="900" fill="#C0392B" textAnchor="middle">+6</text>
                <text x="15" y="25" fontSize={cornerSize - 2} fontWeight="bold" fill="white" textAnchor="middle">+6</text>
                <text x="85" y="140" fontSize={cornerSize - 2} fontWeight="bold" fill="white" textAnchor="middle">+6</text>
            </>
        );
    }

    if (value === 'wild_draw10') {
        return (
            <>
                <WildSquares />
                <text x="50" y="115" fontSize="18" fontWeight="900" fill="#8E44AD" textAnchor="middle">+10</text>
                <text x="15" y="25" fontSize={cornerSize - 3} fontWeight="bold" fill="white" textAnchor="middle">+10</text>
                <text x="85" y="140" fontSize={cornerSize - 3} fontWeight="bold" fill="white" textAnchor="middle">+10</text>
            </>
        );
    }

    if (value === 'wild_reverse_draw4') {
        return (
            <>
                <rect x="30" y="50" width="15" height="15" fill="#E74C3C" />
                <rect x="55" y="50" width="15" height="15" fill="#F39C12" />
                <rect x="30" y="75" width="15" height="15" fill="#27AE60" />
                <rect x="55" y="75" width="15" height="15" fill="#3498DB" />
                <path d="M 35 105 L 45 95 L 45 100 Q 55 100, 60 105" fill="none" stroke="#2C3E50" strokeWidth="2" />
                <polygon points="60,105 65,100 65,110" fill="#2C3E50" />
                <text x="50" y="125" fontSize="16" fontWeight="900" fill="#C0392B" textAnchor="middle">+4</text>
                <text x="15" y="25" fontSize={cornerSize - 4} fontWeight="bold" fill="white" textAnchor="middle">R+4</text>
                <text x="85" y="140" fontSize={cornerSize - 4} fontWeight="bold" fill="white" textAnchor="middle">R+4</text>
            </>
        );
    }

    if (value === 'wild_color_roulette') {
        return (
            <>
                <circle cx="50" cy="75" r="24" fill="none" stroke="#2C3E50" strokeWidth="3.5" />
                <path d="M50 51 L50 99" stroke="#2C3E50" strokeWidth="2.5" />
                <path d="M26 75 L74 75" stroke="#2C3E50" strokeWidth="2.5" />
                <path d="M33 58 L67 92" stroke="#2C3E50" strokeWidth="2.5" />
                <path d="M67 58 L33 92" stroke="#2C3E50" strokeWidth="2.5" />
                <circle cx="50" cy="75" r="4" fill="#2C3E50" />
                <path d="M50 53 L57 63 L43 63 Z" fill="#E74C3C" />
                <path d="M72 75 L62 82 L62 68 Z" fill="#F39C12" />
                <path d="M50 97 L43 87 L57 87 Z" fill="#27AE60" />
                <path d="M28 75 L38 68 L38 82 Z" fill="#3498DB" />
                <text x="15" y="25" fontSize={cornerSize - 5} fontWeight="bold" fill="white" textAnchor="middle">WR</text>
                <text x="85" y="140" fontSize={cornerSize - 5} fontWeight="bold" fill="white" textAnchor="middle">WR</text>
            </>
        );
    }

    return (
        <>
            <WildSquares />
            <text x="50" y="115" fontSize="14" fontWeight="900" fill="#2C3E50" textAnchor="middle">{value}</text>
        </>
    );
}

function UnoCard({ card, faceDown, isPlayable, onClick, size = 'normal' }) {
    const { width, height, fontSize, cornerSize } = sizes[size] || sizes.normal;

    if (faceDown) {
        return (
            <svg
                width={width}
                height={height}
                viewBox="0 0 100 150"
                className={isPlayable ? 'gn-uno-card gn-uno-card-playable' : 'gn-uno-card'}
                style={{
                    cursor: isPlayable ? 'pointer' : 'default',
                    fontFamily: CARD_FONT,
                    '--gn-card-brightness': isPlayable ? 1 : 0.8,
                    '--gn-card-glow': 'rgba(214, 90, 49, 0.55)'
                }}
                onClick={isPlayable ? onClick : undefined}
            >
                <rect x="2" y="2" width="96" height="146" rx="8" fill="#2C3E50" stroke="white" strokeWidth="3" />
                <text x="50" y="85" fontSize="28" fontWeight="900" fill="white" textAnchor="middle">UNO</text>
            </svg>
        );
    }

    if (!card) return null;

    const cardColor = CARD_COLORS[card.color] || '#34495E';
    const handleClick = () => {
        if (isPlayable && onClick) {
            onClick(card);
        }
    };

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 100 150"
            className={isPlayable ? 'gn-uno-card gn-uno-card-playable' : 'gn-uno-card'}
            style={{
                cursor: isPlayable ? 'pointer' : 'default',
                fontFamily: CARD_FONT,
                '--gn-card-brightness': isPlayable ? 1 : 0.7,
                '--gn-card-glow': hexToRgba(cardColor, 0.55)
            }}
            onClick={handleClick}
        >
            <rect x="2" y="2" width="96" height="146" rx="8" fill={cardColor} stroke="white" strokeWidth="3" />
            <ellipse cx="50" cy="75" rx="35" ry="50" fill="white" />

            {card.card_type === 'number' && <NumberFace value={card.value} fontSize={fontSize} cornerSize={cornerSize} cardColor={cardColor} />}
            {card.card_type === 'action' && <ActionFace value={card.value} cornerSize={cornerSize} cardColor={cardColor} fontSize={fontSize} />}
            {card.card_type === 'wild' && <WildFace value={card.value} cornerSize={cornerSize} />}
        </svg>
    );
}

export default UnoCard;
